import React from 'react';
import { useNavigate } from 'react-router-dom';

export const CustomerTable = ({ customers, isLoading, statusClassMap, formatDate }) => {
    const skeletonRows = Array.from({ length: 8 }, (_, index) => index);
    const navigate = useNavigate();

    const handleRowClick = (customerId, customerName) => {
        navigate(`/customer/detail/${customerId}`, {
            state: {
                customerName,
            },
        });
    };

    return (
        <div className="table-responsive border rounded-3">
            <table className="table table-hover align-middle mb-0">
                <thead>
                    <tr>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Código</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Compañía</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Contacto</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Email</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Teléfono</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Estatus</th>
                        <th className="text-uppercase fs-11 fw-semibold py-3">Alta</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading && (
                        <>
                            {skeletonRows.map((row) => (
                                <tr key={`customer-skeleton-${row}`}>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--badge"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--name"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--contact"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--email"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--phone"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--status"></div></td>
                                    <td className="py-2"><div className="table-skeleton table-skeleton--date"></div></td>
                                </tr>
                            ))}
                        </>
                    )}
                    {!isLoading && customers.map((customer) => (
                        <tr key={customer._id}>
                            <td className="py-0">
                                <span className="link__nocolor badge bg-soft-primary text-primary" onClick={() => handleRowClick(customer._id, customer.name)}>{customer.code}</span>
                            </td>
                            <td className="py-0">
                                <div className="link fw-semibold" onClick={() => handleRowClick(customer._id, customer.name)}>{customer.name}</div>
                            </td>
                            <td>
                                <div className="fw-semibold">{customer.contactName}</div>
                            </td>
                            <td>
                                <div className="fs-12 text-muted">{customer.contactEmail}</div>
                            </td>
                            <td className="py-0">{customer.contactPhone}</td>
                            <td>
                                <span className={`badge ${statusClassMap[customer.status] || 'bg-soft-secondary text-secondary'}`}>
                                    {customer.status}
                                </span>
                            </td>
                            <td className="py-0">{formatDate(customer.joinDate)}</td>
                        </tr>
                    ))}
                    {!isLoading && customers.length === 0 && (
                        <tr>
                            <td colSpan={7} className="text-center text-muted py-4">
                                No se encontraron clientes con ese criterio de búsqueda.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};
